import type { ApiErrorPayload } from '../types/error'

export const isErrorPayload = (err: unknown): err is ApiErrorPayload =>
  !!(
    err &&
    typeof err === 'object' &&
    '__type__' in err &&
    (err as any).__type__ === 'api_error_payload'
  )
